


























import Vue from 'vue';
import { DetailedEmailCampaign } from '@/types';
import Summary from './Summary.vue';
import Opens from './Opens.vue';
import Clicks from './Clicks.vue';
import LinkActivities from './LinkActivities.vue';
import Unsubscribers from './Unsubscribers.vue';
import Bounces from './Bounces.vue';

export default Vue.extend({
  props: {
    emailCampaign: {
      type: Object as () => DetailedEmailCampaign,
      required: true,
    },
  },
  components: {
    'report-summary': Summary,
    opens: Opens,
    clicks: Clicks,
    'link-activities': LinkActivities,
    unsubscribers: Unsubscribers,
    bounces: Bounces,
  },
});
